import {createReducer} from '../utility'




export const membershipGrade = createReducer({},{
    "FETCH_MEMBERSHIP_GRADES_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                grades: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})